import { useWindowDimensions } from "react-native";

export function useOrgSpaceUnitSize() {
  const window = useWindowDimensions();
  if (window.width > 1024) {
    return 200;
  }

  if (window.width > 778) {
    return 140;
  }
  return 130;
}
